import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import UseAIImage from './UseAIImage'

const copy = {
  heading: `Use AI to turn every customer interaction into a unique customer experience`,
  description: `Segment makes it easier than ever to understand, predict, generate, and engage each individual customer in real-time and at scale.`,
  buttonText: `Learn more`,
  buttonUrl: `/solutions/ai/`,
}

const UseAI: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <StyledSectionBase variant="2Col">
        <Section.Contents>
          <UseAIImage alt={`Illustration: ${copy.heading}`} />
        </Section.Contents>
        <StyledCopy alignSelf="center">
          <CopyTextBase>
            <CopyText.Heading tag="h2" variant="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pLarge">
              {copy.description}
            </CopyText.Description>
            <CopyText.Link href={getAbsoluteUrl(copy.buttonUrl, pageConfig)}>{copy.buttonText}</CopyText.Link>
          </CopyTextBase>
        </StyledCopy>
      </StyledSectionBase>
    </Wrapper>
  )
}

export default UseAI

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`
